import { applyHighchartsTheme } from "../utils/highcharts_theme"

export const NERTrends = {
  mounted() {
    this.handleEvent("render-ner-trends", ({ chart_data }) => {
      this.renderChart(chart_data)
    })

    // Also render on mount if data is present
    const chartData = this.el.dataset.chart
    if (chartData) {
      this.renderChart(JSON.parse(chartData))
    }
  },

  renderChart(chartData) {
    const currencySymbol = chartData.currency_symbol || ""
    const areaUnit = chartData.area_unit || ""

    import("highcharts").then((Highcharts) => {
      applyHighchartsTheme(Highcharts.default)
      Highcharts.default.chart(this.el.id, {
        chart: {
          type: "line",
          // Highcharts 13 defaults chart.backgroundColor to a CSS var that
          // renders dark under prefers-color-scheme: dark; keep it explicit.
          backgroundColor: "transparent",
        },
        title: {
          text: null,
        },
        xAxis: {
          categories: chartData.categories,
          title: {
            text: "Time Period",
          },
        },
        yAxis: {
          title: {
            text: `Net Effective Rent (${currencySymbol}/${areaUnit})`,
          },
          min: 0,
        },
        legend: {
          enabled: false,
        },
        tooltip: {
          valuePrefix: currencySymbol,
          valueSuffix: `/${areaUnit}`,
          valueDecimals: 2,
        },
        plotOptions: {
          line: {
            color: "#14b8a6",
            dataLabels: {
              enabled: false,
            },
            marker: {
              enabled: true,
              radius: 4,
            },
          },
        },
        series: [
          {
            name: "Median NER",
            data: chartData.data,
          },
        ],
        credits: {
          enabled: false,
        },
      })
    })
  },
}
